import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { EMPTY_VALUE } from 'src/app/_helpers/utils';
import { CancellationFlowHistoryEntry } from 'src/app/_types/cancellation.types';

import { describeChange } from './cancellation-log-change';

/** "Modifications" cell: one line per edited field, or a dash. */
@Component({
  selector: 'app-cancellation-log-changes-renderer',
  standalone: true,
  template: `
    @for (line of lines; track $index) {
      <div>{{ line }}</div>
    } @empty {
      {{ empty }}
    }
  `,
})
export class CancellationLogChangesRendererComponent
  implements ICellRendererAngularComp
{
  lines: string[] = [];

  readonly empty = EMPTY_VALUE;

  agInit(params: ICellRendererParams<CancellationFlowHistoryEntry>): void {
    this.lines = (params.data?.changes ?? []).map(describeChange);
  }

  refresh(): boolean {
    return false;
  }
}
